// X216: the 250-country catalogue, fetched once per page load and shared by every country field (a dialog with a row
// per club would otherwise fetch it once per row). Our own list: a club or user stores an id from it, never a name.
import {ref} from 'vue';
import {useHttpRequest} from '~/composables/useHttpRequest';
import {endpoints} from '~/network/endpoints.js';
import {withDisplayName} from '~/utils/countryNames';

const countries = ref([]);
const pending = ref(false);
let loading = null;

export function useCountryList() {
  const {httpRequest} = useHttpRequest();
  const load = () => {
    if (countries.value.length) return Promise.resolve(countries.value);
    if (!loading) {
      pending.value = true;
      loading = httpRequest(endpoints.countries.getItems, null)
          .then((res) => { countries.value = (res?.items ?? res ?? []).map(withDisplayName); return countries.value; }) // X221: natural names
          .catch(() => { loading = null; return []; })
          .finally(() => { pending.value = false; });
    }
    return loading;
  };
  /** A country by id or ISO code from the list in hand, or null. */
  const find = (idOrIso) => countries.value.find((c) => c.id === idOrIso || (idOrIso && c.isoCode?.toUpperCase() === String(idOrIso).toUpperCase())) ?? null;
  return {countries, pending, load, find};
}
